import React from "react";
import PoweredBy from "../components/PoweredBy";
import { Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import { PublicShell, Tile, useBrand } from "./PublicHome";

// Area riservata (non autenticata): stesso shell della Home pubblica, pulsanti quadrati brand.
export default function ClientHome() {
  const { settings, brand } = useBrand();
  return (
    <PublicShell title="Area riservata" back="/home" testid="client-home">
      <div className="rounded-3xl bg-white p-2 shadow-sm ring-1 ring-zinc-200">
        <div className="rounded-2xl p-6 text-center" style={{ background: brand, color: "#fff" }} data-testid="client-home-hero">
          <div className="font-heading font-extrabold text-2xl">Benvenuto nella tua area riservata</div>
          <p className="text-sm opacity-90 mt-2 max-w-xs mx-auto">Accedi alla tua card fedeltà {settings.app_name || ""} o registrane una nuova per iniziare a raccogliere punti.</p>
        </div>
      </div>
      <section className="grid grid-cols-2 gap-4 max-w-sm mx-auto" data-testid="client-home-actions">
        <Tile to="/cliente/accedi" icon={LogIn} label="Accedi" brand={brand} testid="client-home-login" />
        <Tile to="/registrati" icon={UserPlus} label="Registrati" brand={brand} testid="client-home-register" />
      </section>
      <p className="text-center text-xs text-zinc-500" data-testid="client-home-accent-hint">Volantino, coupon e offerte disponibili dopo l'accesso</p>
      <footer className="text-center pt-6 text-xs text-zinc-400 space-x-4">
        <Link to="/home" className="hover:text-zinc-700" data-testid="client-home-public-home">Home</Link>
        <span className="text-zinc-300">·</span>
        <Link to="/scopri" className="hover:text-zinc-700" data-testid="client-home-more">Scopri di più</Link>
        <span className="text-zinc-300">·</span>
        <Link to="/login" className="hover:text-zinc-700" data-testid="client-home-staff">Area operatori</Link>
      </footer>
      <div className="flex justify-center"><PoweredBy testid="client-home-powered-by" /></div>
    </PublicShell>
  );
}
